module.exports = __webpack_public_path__ + "img/local_bar.f2773f90.svg";